import React from 'react';
import TicketAdminPanel from '../../../components/TicketAdminPanel/TicketAdminPanel';
import './TicketManagement.css';

const TicketManagement = () => {
    return (
        <div className="ticket-management-page">
            <TicketAdminPanel />
        </div>
    );
};

export default TicketManagement;
